<template>
  <v-dialog
    max-width="400"
    :value="true"
    @click:outside="$emit('cancel')"
  >
    <v-card>
      <v-card-title>
        <h2>{{ newProduct ? '' : 'Edit' }} Loan Product Name:</h2>
      </v-card-title>

      <v-card-text>
        <p>
          This is an internal name for you to identify your different products
        </p>
        <v-text-field v-model="internalName" solo />
      </v-card-text>

      <v-card-actions>
        <button
          class="default-btn blue"
          :disabled="!internalName.length"
          @click="$emit('submit', internalName)"
        >Create Loan Product</button>

        <button class="default-btn text" @click="$emit('cancel')">Cancel</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogInternalName',
  props: {
    newProduct: {
      type: Boolean,
      default: false,
    },
    existingName: String,
  },

  data: () => ({
    internalName: '',
  }),

  created () {
    this.internalName = this.existingName || ''
  },
}
</script>

<style lang="scss" scoped></style>
